module.exports = __webpack_public_path__ + "img/gate_grey_logo.7d283c0f.png";